import type { DailyCapacity, Team } from '../../DTOS/ResourcePlanning';

export const DEFAULT_DAILY_MINUTES = 480;

/** A personal daily exception takes priority; membership end dates are exclusive. */
export const dailyCapacity = (teams: Team[], userId: string, date: string, overrides: DailyCapacity[] = []) => {
  const override = overrides.find(row => row.userId === userId && row.date === date);
  if (override) return override.minutes;
  return teams.find(team => team.memberships.some(member => member.userId === userId && member.validFrom <= date
    && (!member.validTo || member.validTo > date)))?.dailyMinutes ?? DEFAULT_DAILY_MINUTES;
};
